// 1) Define polyfill first
if (!window?.crypto?.randomUUID) {
  window.crypto.randomUUID = (): any => {
    const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return template.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };
}

import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'

const target = document.getElementById('app')!;
// Clear pre-rendered HTML before Svelte mounts to prevent duplication
target.innerHTML = '';

const app = mount(App, {
  target,
})

export default app
